import React, { Component, useEffect, useState } from 'react';
import EmplNavigation from '../../../components/EmplNavigation/EmplNavigation';
import { ProSidebarProvider } from 'react-pro-sidebar';
import styles from './Dashboard.module.css';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import EmplTraining from '../EmplTraining/EmplTraining';
import EmpSidePanel from '../../../components/EmpSidePanel/EmpSidePanel';
import { Util } from '../../../config/Util';
import EmplHome from '../EmplHome/EmplHome';
import EmplCommunication from '../EmplCommunication/EmplCommunication';
import EmplAssessment from '../EmplAssessment/EmplAssessment';
import EmplSetting from '../EmplSetting/EmplSetting';
import Manager from '../Manager/Manager';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Submissions from '../../Common/Ibtikar/Submissions';
import Facilitation from '../../Common/Ibtikar/Facilitation';
import Implementation from '../../Common/Ibtikar/Implementation';
import Leader from '../../Common/Ibtikar/Leader';
const Dashboard = () => {


  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (Util.loginStatus) {
      const usernameElement = document.getElementById("username");
      if (usernameElement) {
        usernameElement.innerHTML = "Welcome, " + Util.user;
      }
      history.push("/user/home");
    } else {
      history.push("/login");
    }
  }, [history]);

  return (
    <React.Fragment>
      <div className={styles.admin_dashboard_wrapper}>
        <div className={styles.navbar_wrapper}>
          <header className=''>
            <EmplNavigation />
          </header>
        </div>
        <div className={styles.home_content_wrapper}>
          <div className={`overflow-auto ${styles.side_bar_wrap}`}>
            <ProSidebarProvider>
              <EmpSidePanel collapsed={collapsed} setCollapsed={setCollapsed} />
            </ProSidebarProvider>
          </div>

          <div className={`${styles.admin_content_section} ${collapsed ? styles.collapsed : styles.expanded}`}>

            <Switch>
              <Route path="/user/home" >
                <EmplHome/>
              </Route>
              <Route path="/user/communication" >
                <EmplCommunication />
              </Route>

              <Route path="/user/training" >
                <EmplTraining />
              </Route>

              <Route path="/user/assessment" >
                <EmplAssessment />
              </Route>

              <Route path="/user/manager" >
                <Manager />
              </Route>

              <Route path="/user/settings" >
                <EmplSetting />
              </Route>

              <Route path="/user/ibtikar/submissions" >
                <Submissions />
              </Route>

              <Route path="/user/ibtikar/implementation" >
                <Implementation />
              </Route>

              <Route path="/user/ibtikar/facilitation" >
                <Facilitation />
              </Route>

              <Route path="/user/ibtikar/leader-dashboard">
                <Leader/>
              </Route>

              <Route path="/user/*" >
                <Redirect to='/landing' />
              </Route>
            </Switch>


          </div>
        </div>
      </div>
      {/* <div className='row footer-wrap'>
          <Footer/>
        </div> */}
    </React.Fragment>

  )
}

export default Dashboard;